import React, { useState, useEffect } from 'react';
import { cloneDeep } from 'lodash';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import AccountService from './account-service';
import AccountRow from './account-row';
import { SearchBar } from '../../ui/search';
import CreateAccountModal from './create-account-modal';

import './styles/account-overview.scss';

const AccountOverview = ({ history, flags }) => {
  const headers = [
    'logo',
    'company',
    'account type',
    ...(flags.accountCategorization ? ['categories'] : []),
    'terms accepted',
  ];

  const [accounts, setAccounts] = useState([]);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [queryString, setQueryString] = useState('');
  const [companySort, setCompanySort] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const sortAsc = (a, b) => (a.full_name.toLowerCase() > b.full_name.toLowerCase() ? 1 : -1);
  const sortDesc = (a, b) => (a.full_name.toLowerCase() > b.full_name.toLowerCase() ? -1 : 1);

  useEffect(() => {
    getAccounts();
  }, []);

  useEffect(() => {
    const filteredAccounts = !queryString
      ? accounts
      : accounts.filter(account =>
          account.full_name.toLowerCase().includes(queryString.toLowerCase()),
        );
    setFilteredAccounts(filteredAccounts);
  }, [queryString]);

  useEffect(() => {
    const currentAccounts = cloneDeep(filteredAccounts);
    const sortStyle = companySort ? sortAsc : sortDesc;
    currentAccounts.sort(sortStyle);
    setFilteredAccounts(currentAccounts);
  }, [companySort]);

  async function getAccounts() {
    try {
      const pubAccounts = await AccountService.getPublisherAccounts();
      const merchAccounts = await AccountService.getMerchantAccounts();
      const sortedAccounts = [...pubAccounts.data.data, ...merchAccounts.data.data].sort(sortAsc);
      setAccounts(sortedAccounts);
      setFilteredAccounts(sortedAccounts);
    } catch {
      setAccounts([]);
      setFilteredAccounts([]);
    }
  }

  const accountHeaders = headers.map((header, idx) => {
    const company = 'company';
    const caret =
      header === company ? <span className={companySort ? 'caret-up' : 'caret-down'}></span> : null;

    const handleSort = ![company].includes(header) ? () => {} : () => setCompanySort(!companySort);

    return (
      <div key={idx} className={header.replace(/ /g, '-')} onClick={handleSort}>
        <div className="header-content">
          {header}
          {caret}
        </div>
      </div>
    );
  });

  const accountList = filteredAccounts.map((account, idx) => {
    return <AccountRow account={account} key={idx} flags={flags} />;
  });

  const createAccountModal = showModal ? (
    <CreateAccountModal setShowModal={setShowModal} history={history} />
  ) : null;

  return (
    <div className="account-overview-container">
      {createAccountModal}
      <div className="title-area">
        <h1 className="account-label">Accounts</h1>
        <div className="create-account" onClick={() => setShowModal(true)}>
          Create Account
        </div>
      </div>
      <SearchBar placeholder="Search for an Account" onChange={setQueryString} />
      <div className="accounts-table">
        <div className="all-accounts">All Accounts</div>
        <div className="account-headers">{accountHeaders}</div>
        <div className="account-list">{accountList}</div>
      </div>
    </div>
  );
};

export default withLDConsumer()(AccountOverview);
